<template>
    <div class="sidebar-bottom">
      <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item nav-dropdown" :class="{'router-link-exact-active': subIsActive(['usage', 'invoice', 'billing', 'quota'])}">
          <router-link :to="{name: 'billing'}" class="sidebar__usage nav-link">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
              Usage
              <small v-if="hasUsageData">(<span v-if="currentMonthUsage && currentMonthUsage.total">€{{ currentMonthUsage.total }}</span>
              <span v-if="!currentMonthUsage">€0.00</span>)</small>
          </router-link>
        </li>
      </ul>
    </nav>
      <fSidebarTeamProject />
    </div>
</template>

<script>
const fSidebarTeamProject = () => import('@/components/menu/f-sidebar-team-project');
export default {
    computed: {
        currentMonthUsage() {
            let data = this.$store.state.usage.currentMonth;
            if (data) {
                this.isLoading = false;
                return data;
            } else {
                this.isLoading = true;
                return false;
            }
        },
    },

    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
              if (this.$route.meta.sidebar) {
                  return this.$route.meta.sidebar.indexOf(path) > -1;
              }
            });
        },
    },

    components: {
        fSidebarTeamProject,
    }
}
</script>
